import { get, map, isEmpty, isArray } from "lodash";
import { Result, Row, Col, Divider } from "antd";
import { searchPage } from "grandus-lib/utils/fetches";
import {
  getSearchLinkAttributes,
  getSearchLinkAttributesFromRouter,
  paramsToPath,
} from "grandus-lib/hooks/useFilter";
import { FrownOutlined } from "@ant-design/icons";
import styles from "pages/kategoria/category.page.module.scss";
import { useEffect, useState } from "react";

import ProductCard from "components/product/card/ProductCard";
import Breadcrumbs from "components/breadcrumbs/Breadcrumbs";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import Remarketing from "grandus-lib/utils/remarketing";
import TagManager from "grandus-lib/utils/gtag";
import EnhancedEcommerce from "utils/ecommerce";
const Pagination = dynamic(() => import("components/pagination/Pagination"));
const MetaData = dynamic(() =>
  import("grandus-lib/components-atomic/MetaData")
);
const CategoryParameters = dynamic(
  () => import("components/category/CategoryParameters"),
  { ssr: false }
);
const CategoryOrdering = dynamic(
  () => import("components/category/CategoryOrdering"),
  { ssr: false }
);
const CategorySelected = dynamic(
  () => import("components/category/CategorySelected"),
  { ssr: false }
);

const handleGetData = (router, newState) => {
  const data = getSearchLinkAttributes(
    get(router, "query.term"),
    paramsToPath(newState),
    get(router, "query"),
    { toDelete: ["term", "parameters", "page"] },
    router
  );

  return data;
};

const handleOrderingLinkAttributes = (router, ordering) => {
  return getSearchLinkAttributesFromRouter(router, {
    dataToChange: { orderBy: ordering },
    toDelete: ["term", "parameters", "page"],
  });
};

const handlePaginationLinkAttributes = (router, data) => {
  return getSearchLinkAttributesFromRouter(router, data);
};

const Search = (props) => {
  const { products, pagination, filter, meta, breadcrumbs } = props;
  const router = useRouter();
  const [openedFilter, setOpenedFilter] = useState(false);
  const onClickToggleOpen = () => {
    setOpenedFilter(!openedFilter);
  };

  useEffect(() => {
    const list = "search";
    TagManager.push(
      EnhancedEcommerce.impressions(products, list, {
        page: pagination?.currentPage,
        perPage: pagination?.perPage,
      })
    );
    TagManager.push(Remarketing.viewSearchResults(products));
  }, [products]);

  return (
    <main className="container guttered">
      <Breadcrumbs data={breadcrumbs} />
      <MetaData {...meta} />
      <Row justify="space-around">
        <Col xs={24} md={8} lg={4}>
          <div className={styles.container}>
            <button className={styles.filterButton} onClick={onClickToggleOpen}>
              <svg
                height={32}
                width={32}
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>check list</title>
                <g
                  fill="#ffffff"
                  stroke="#ffffff"
                  strokeLinecap="round"
                  strokeWidth="2"
                >
                  <line
                    fill="none"
                    stroke="#ffffff"
                    x1="21"
                    x2="44"
                    y1="8"
                    y2="8"
                  />
                  <line fill="none" x1="21" x2="44" y1="24" y2="24" />
                  <line
                    fill="none"
                    stroke="#ffffff"
                    x1="21"
                    x2="44"
                    y1="40"
                    y2="40"
                  />
                  <rect
                    height="10"
                    width="10"
                    fill="none"
                    stroke="#ffffff"
                    x="4"
                    y="3"
                  />
                  <rect
                    height="10"
                    width="10"
                    fill="none"
                    stroke="#ffffff"
                    x="4"
                    y="35"
                  />
                  <polyline fill="none" points="4 24 8 28 15 19" />
                </g>
              </svg>
            </button>
          </div>

          <div
            className={[styles.sidebar, openedFilter ? styles.open : ""].join(
              " "
            )}
          >
            <button className={styles.filterButton} onClick={onClickToggleOpen}>
              <svg
                height={32}
                width={32}
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>filter</title>
                <g
                  fill="#ffffff"
                  stroke="#ffffff"
                  strokeLinecap="round"
                  strokeWidth="2"
                >
                  <polygon
                    fill="none"
                    points="44 8 28 24 28 38 20 44 20 24 4 8 4 2 44 2 44 8"
                    stroke="#ffffff"
                  />
                </g>
              </svg>
            </button>
            <CategoryParameters
              initialData={filter}
              handleGetData={handleGetData}
            />
          </div>
        </Col>
        <Col xs={24} md={16} lg={20}>
          <div className={styles.container}>
            <h1 className={styles.headline}>
              Hľadaný výraz: "{get(router, "query.term")}"
            </h1>

            <CategorySelected handleGetData={handleGetData} />
            <CategoryOrdering
              handleLinkAttributes={handleOrderingLinkAttributes}
            />

            {isArray(products) && !isEmpty(products) ? (
              <Row gutter={[8, 8]}>
                {map(products, (product, index) => {
                  return (
                    <Col
                      xs={12}
                      sm={8}
                      md={8}
                      lg={6}
                      key={`products-search-${product.id}-${index}`}
                    >
                      <ProductCard
                        {...product}
                        options={{
                          eecProduct: {
                            position: index + 1,
                            page: pagination?.currentPage,
                            perPage: pagination?.perPage,
                          },
                        }}
                      />
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <Result
                icon={<FrownOutlined />}
                title="Ľutujeme, nenašli sa produkty"
                subTitle={`Vášmu výberu nezodpovedaju žiadne produkty. Zmente prosím kategóriu alebo kombináciu filtrov.`}
              />
            )}

            <Divider />
            <Pagination
              {...pagination}
              handleLinkAttributes={handlePaginationLinkAttributes}
            />
          </div>
        </Col>
      </Row>
    </main>
  );
};

export async function getServerSideProps(context) {
  return searchPage.serverSideProps(context);
}

export default Search;
